import script from "./PodcastAdminVideosList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastAdminVideosList.vue?vue&type=script&setup=true&lang=js"

import "./PodcastAdminVideosList.vue?vue&type=style&index=0&id=5d292d2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d292d2c"]])

export default __exports__